export default __webpack_public_path__ + "static/media/Ben George.efdda32b.jpg";